"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Button", {
    enumerable: true,
    get: function() {
        return Button;
    }
});
var _themetools = require("@chakra-ui/theme-tools");
var _components = require("../../../components");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var ghostButton = {
    color: "text-button-transparent",
    backgroundColor: "transparent",
    loading: {
        borderColor: "text-button-transparent",
        borderBottomColor: (0, _themetools.transparentize)("text-button-transparent", 0.3),
        borderLeftColor: (0, _themetools.transparentize)("text-button-transparent", 0.3)
    },
    _loading: {
        backgroundColor: "background-action-disabled",
        _hover: {
            backgroundColor: "background-action-disabled"
        }
    },
    _disabled: {
        color: (0, _themetools.transparentize)("text-button-transparent", 0.6),
        opacity: 1,
        backgroundColor: "transparent"
    },
    _hover: {
        backgroundColor: "background-action-hover",
        _disabled: {
            color: (0, _themetools.transparentize)("text-button-transparent", 0.6),
            opacity: 1
        }
    },
    _focus: {
        backgroundColor: "background-action-hover",
        boxShadow: "0 0 0 0.1875rem var(--chakra-colors-primary-focus)"
    },
    _pressed: {
        backgroundColor: "background-action-pressed"
    },
    _active: {
        backgroundColor: "background-action-pressed"
    }
};
var generateButton = function(color, textColor) {
    var _disabled = {
        backgroundColor: "".concat(color, "-disabled"),
        opacity: 1,
        color: (0, _themetools.transparentize)("text-button-".concat(textColor || color), 0.6)
    };
    var loadingStyles = {
        borderColor: "".concat(color, "-default"),
        borderBottomColor: (0, _themetools.transparentize)("".concat(color, "-default"), 0.3),
        borderLeftColor: (0, _themetools.transparentize)("".concat(color, "-default"), 0.3)
    };
    if (color === "secondary" || color === "alert-error") {
        loadingStyles = {
            borderColor: "text-light",
            borderBottomColor: (0, _themetools.transparentize)("text-light", 0.3),
            borderLeftColor: (0, _themetools.transparentize)("text-light", 0.3)
        };
    }
    return {
        color: "text-button-".concat(textColor || color),
        backgroundColor: "".concat(color, "-default"),
        loading: loadingStyles,
        _disabled: _disabled,
        _hover: {
            backgroundColor: "".concat(color, "-hover"),
            _disabled: _disabled
        },
        _focus: {
            backgroundColor: "".concat(color, "-hover"),
            boxShadow: "0 0 0 0.1875rem var(--chakra-colors-".concat(color, "-focus)")
        },
        _pressed: {
            backgroundColor: "".concat(color, "-pressed")
        },
        _active: {
            backgroundColor: "".concat(color, "-pressed")
        }
    };
};
var generateAltButton = function(color) {
    var _disabled = {
        backgroundColor: "background-action-disabled",
        opacity: 1,
        color: (0, _themetools.transparentize)("text-link-".concat(color, "-default"), 0.6),
        border: "1px solid ".concat(color, "-disabled")
    };
    return {
        position: "relative",
        backgroundColor: "background-action-default",
        color: "text-link-".concat(color, "-default"),
        loading: {
            borderColor: "primary-default",
            borderBottomColor: (0, _themetools.transparentize)("primary-default", 0.3),
            borderLeftColor: (0, _themetools.transparentize)("primary-default", 0.3)
        },
        _disabled: _disabled,
        _hover: {
            backgroundColor: "background-action-hover",
            color: "text-link-".concat(color, "-hover"),
            _disabled: _disabled,
            _before: {
                border: "1px solid var(--chakra-colors-".concat(color, "-hover)")
            }
        },
        _focus: {
            backgroundColor: "background-action-default",
            boxShadow: "0 0 0 0.1875rem var(--chakra-colors-".concat(color, "-focus)")
        },
        _pressed: {
            backgroundColor: "background-action-pressed",
            _before: {
                border: "1px solid var(--chakra-colors-".concat(color, "-pressed)")
            }
        },
        _active: {
            backgroundColor: "background-action-pressed",
            _before: {
                border: "1px solid var(--chakra-colors-".concat(color, "-pressed)")
            }
        },
        _before: {
            content: '""',
            position: "absolute",
            top: "-1px",
            right: "-1px",
            bottom: "-1px",
            left: "-1px",
            border: "1px solid var(--chakra-colors-".concat(color, "-default)"),
            borderRadius: "radii-button"
        }
    };
};
var getLinkVariants = function() {
    return _components.linkVariants.reduce(function(prev, variant) {
        return _object_spread_props(_object_spread({}, prev), _define_property({}, variant, function(params) {
            var variantValue = params.theme.components.Link.variants[variant];
            return typeof variantValue === "function" ? variantValue(params) : variantValue;
        }));
    }, {});
};
var getTextStyleProperties = function(textStyle) {
    var fontSize = textStyle.fontSize, fontWeight = textStyle.fontWeight, letterSpacing = textStyle.letterSpacing, lineHeight = textStyle.lineHeight, textDecoration = textStyle.textDecoration, fontFamily = textStyle.fontFamily;
    return {
        fontSize: fontSize,
        fontWeight: fontWeight,
        letterSpacing: letterSpacing,
        lineHeight: lineHeight,
        textDecoration: textDecoration,
        fontFamily: fontFamily
    };
};
var Button = {
    baseStyle: {
        borderRadius: "radii-button"
    },
    sizes: {
        xs: function(param) {
            var theme = param.theme;
            return _object_spread_props(_object_spread({}, getTextStyleProperties(theme.textStyles["text-body-floating-label-medium"])), {
                px: "spacer-button-x-XS",
                py: "spacer-button-y-XS",
                loading: {
                    width: "0.75rem",
                    height: "0.75rem",
                    padding: 0
                },
                columnGap: "spacer-button-gap-XS"
            });
        },
        s: function(param) {
            var theme = param.theme;
            return _object_spread_props(_object_spread({}, getTextStyleProperties(theme.textStyles["text-body-meta-medium"])), {
                px: "spacer-button-x-S",
                py: "spacer-button-y-S",
                loading: {
                    width: "0.75rem",
                    height: "0.75rem",
                    padding: 0
                },
                columnGap: "spacer-button-gap-S"
            });
        },
        m: function(param) {
            var theme = param.theme;
            return _object_spread_props(_object_spread({}, getTextStyleProperties(theme.textStyles["text-body-medium"])), {
                px: "spacer-button-x-M",
                py: "spacer-button-y-M",
                loading: {
                    width: "1rem",
                    height: "1rem",
                    padding: 0
                },
                columnGap: "spacer-button-gap-M"
            });
        },
        l: function(param) {
            var theme = param.theme;
            return _object_spread_props(_object_spread({}, getTextStyleProperties(theme.textStyles["text-body-large-medium"])), {
                px: "spacer-button-x-L",
                py: "spacer-button-y-L",
                loading: {
                    width: "1rem",
                    height: "1rem",
                    padding: 0
                },
                columnGap: "spacer-button-gap-L"
            });
        }
    },
    variants: _object_spread({
        accent: generateButton("accent"),
        primary: generateButton("primary"),
        secondary: generateButton("secondary"),
        "primary-alt": generateAltButton("primary"),
        "secondary-alt": generateAltButton("secondary"),
        destroy: generateButton("alert-error", "alert"),
        ghost: ghostButton
    }, getLinkVariants()),
    defaultProps: {
        size: "m",
        variant: "primary"
    }
};
